module.exports = __webpack_public_path__ + "img/home-cases-4.6de01dfd.png";